import { useTranslation } from 'react-i18next';

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
            <div className="absolute top-12 left-12 opacity-10">
              <svg width="120" height="100" viewBox="0 0 120 100" fill="none">
                <path
                  d="M0 100V55C0 24.7 24.7 0 55 0h10v20H55C35.7 20 20 35.7 20 55v45H0zm65 0V55c0-30.3 24.7-55 55-55h10v20h-10c-19.3 0-35 15.7-35 35v45H65z"
                  fill="currentColor"
                  className="text-background-50"
                />
              </svg>
            </div>

            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-[30%] relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20man%20in%20casual%20blazer%20against%20warm%20neutral%20studio%20background%2C%20soft%20natural%20lighting%20from%20window%2C%20editorial%20fashion%20portrait%20photography%2C%20warm%20beige%20and%20cream%20tones%2C%20clean%20minimalist%20aesthetic%2C%20relaxed%20expression%2C%20high%20detail%2C%20professional%20look&width=600&height=800&seq=yoybuy-testimonial-portrait&orientation=portrait"
                  alt={t('testimonial.name', 'Алексей Морозов')}
                  className="w-full h-[300px] md:h-[400px] lg:h-full object-cover object-top rounded-t-3xl lg:rounded-l-3xl lg:rounded-tr-none"
                />
              </div>

              <div className="lg:w-[70%] flex flex-col justify-center px-8 py-10 md:px-14 md:py-16">
                <p className="text-lg md:text-2xl text-background-50 leading-relaxed">
                  {t('testimonial.quote', '')}
                </p>

                <div className="mt-8">
                  <p className="text-base font-semibold text-background-50">
                    {t('testimonial.name', 'Алексей Морозов')}
                  </p>
                  <p className="text-sm text-background-50/60 mt-1">
                    {t('testimonial.role', 'Владелец интернет-магазина')}
                  </p>
                </div>

                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="mt-8 inline-flex items-center justify-center px-8 py-3 rounded-full bg-accent-100/80 text-accent-900 font-semibold text-sm whitespace-nowrap transition-all duration-300 hover:bg-accent-200 w-fit cursor-pointer"
                >
                  {t('testimonial.cta', 'Попробовать YOYBUY')}
                </a>
              </div>
            </div>

            <div className="absolute top-0 right-0 w-40 h-40 opacity-10">
              <svg viewBox="0 0 200 200" fill="none">
                <path
                  d="M0 100 Q 50 20 100 50 Q 150 80 200 30"
                  stroke="currentColor"
                  className="text-accent-500"
                  strokeWidth="1.5"
                  fill="none"
                />
                <path
                  d="M0 120 Q 60 40 110 70 Q 160 100 200 50"
                  stroke="currentColor"
                  className="text-accent-500"
                  strokeWidth="1"
                  fill="none"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}